import React from "react";
import SelectField from "react-md/lib/SelectFields";
import PropTypes from "prop-types";

const ChangeLaneStatus = ({ status, onLaneStatusChange }) => {
  const menuItems = [
    { label: "Open", value: "open" },
    { label: "Reserved", value: "reserved" },
    { label: "Not Available", value: "not-available" }
  ].filter(item => item.value !== status);

  return (
    <div className="md-grid" style={{ paddingTop: 20 }}>
      <h6 className="md-cell md-cell--12 md-title">Change lane status</h6>
      <SelectField
        onChange={onLaneStatusChange}
        style={{ minWidth: 300 }}
        id="status"
        label="New Status"
        menuItems={menuItems}
        itemLabel="label"
        itemValue="value"
        className="md-cell md-cell--12"
        required
      />
    </div>
  );
};

ChangeLaneStatus.propTypes = {
  status: PropTypes.string.isRequired,
  onLaneStatusChange: PropTypes.func.isRequired
};

export default ChangeLaneStatus;



// WEBPACK FOOTER //
// ./src/staff/components/LaneDrawer/ChangeLaneStatus.jsx